'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCROLL_LOAD_THRESHOLD = 10;

var InfiniteScroll = _react2.default.createClass({
  displayName: 'InfiniteScroll',

  propTypes: {
    children: _react.PropTypes.node,
    fetchMore: _react.PropTypes.func.isRequired
  },

  componentDidMount: function componentDidMount() {
    var heightDifference = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;

    this.scrollContainer.scrollTop = heightDifference;
    this.scrollTop = heightDifference;
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateScrollTop();
  },
  getNewScrollTop: function getNewScrollTop() {
    var _scrollContainer = this.scrollContainer,
        scrollTop = _scrollContainer.scrollTop,
        scrollHeight = _scrollContainer.scrollHeight;


    return scrollTop + (scrollHeight - (this.scrollHeight || 0));
  },
  getScrollTopFromBottom: function getScrollTopFromBottom() {
    return this.scrollContainer.scrollHeight + 4;
  },
  scrollContainerToBottom: function scrollContainerToBottom() {
    this.scrollContainer.scrollTop = this.getScrollTopFromBottom();
  },
  setScrollContainerRef: function setScrollContainerRef(element) {
    this.scrollContainer = element ? (0, _reactDom.findDOMNode)(element) : null;
  },
  updateScrollTop: function updateScrollTop() {
    var scrollTop = this.scrollContainer.scrollTop;


    var newScrollTop = this.getNewScrollTop();

    if (newScrollTop !== scrollTop) {
      this.scrollContainer.scrollTop = newScrollTop;
    }

    this.scrollTop = this.scrollContainer.scrollTop;
    this.scrollHeight = this.scrollContainer.scrollHeight;
  },
  isPassedThreshold: function isPassedThreshold() {
    return this.scrollContainer.scrollTop <= SCROLL_LOAD_THRESHOLD;
  },
  onScrollToTop: function onScrollToTop() {
    if (this.scrollContainer.scrollTop !== this.scrollTop) {
      if (this.isPassedThreshold()) {
        this.props.fetchMore();
      }
      // the dom is ahead of the state
      this.updateScrollTop();
    }
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      {
        className: 'messages-scroll-container',
        style: { flexGrow: 1 },
        ref: this.setScrollContainerRef,
        onScroll: this.onScrollToTop
      },
      this.props.children
    );
  }
});

exports.default = InfiniteScroll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/InfiniteScroll.js
// module id = 272
// module chunks = 0 1